import AuthorizationError from './AuthorizationError'

export default AuthorizationError
